import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const TEXT_KEYS = {
    CAPTION: 'friend-referral-program',
    SUBMIT_BUTTON: 'platform-selection__submit-button',
    PAGE_TITLE: 'platform-selection__title',
    PAGE_DESCRIPTION: 'platform-selection__description',
    VALIDATION_ERROR: 'platform-selection__error'
};

export const ANALYTICS_PLATFORM_SELECTION_FLOW_STEP = {
    flowStep: 'platform selection'
};

export const ANALYTICS_PLATFORM_SELECTION_CLICK = (platform: PLATFORM_TYPES) => ({
    ...ANALYTICS_PLATFORM_SELECTION_FLOW_STEP,
    category: CATEGORY.INTERACTION,
    action: `${ANALYTICS_PLATFORM_SELECTION_FLOW_STEP.flowStep} : ${platform}`,
});

export const ANALYTICS_PLATFORM_SELECTION_SUBMIT = (platform: PLATFORM_TYPES) => ({
    ...ANALYTICS_PLATFORM_SELECTION_FLOW_STEP,
    category: CATEGORY.ACTION,
    action: 'submit my code',
    platformSelection: platform
});
